import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-lightning',
  templateUrl: './lightning.component.html',
  styleUrls: ['./lightning.component.scss']
})
export class LightningComponent implements OnInit {
  adminSelected: boolean = true;

  constructor(private utils: UtilsService) { }

  ngOnInit() {
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

}
